/**
 * Mock data para PCF Reconciliation (fondeo FMX -> FSA) — solo dev.
 * Activar con USE_MOCK=true en usePCFReconciliation.
 */

import type { PCFReconciliationData } from '@/types/pcf-reconciliation.types';

export const PCF_MOCK_DATA: PCFReconciliationData = {
  resumen: {
    year: 2026,
    direction: 'FMX_A_FSA',
    totalTransferencias: 35,
    totalMovimientosBanco: 70,
    totals: { ok: 28, salioSinEntrar: 2, entroSinSalir: 1, sinBanco: 3, sinCuadrar: 1 },
  },

  meses: {
    '1': m(3, 0, 0, 0, 0),
    '2': m(4, 0, 0, 1, 0),
    '3': m(3, 1, 0, 0, 0),
    '4': m(3, 0, 1, 0, 0),
    '5': m(3, 0, 0, 0, 0),
    '6': m(2, 1, 0, 1, 0),
    '7': m(3, 0, 0, 0, 0),
    '8': m(2, 0, 0, 1, 0),
    '9': m(2, 0, 0, 0, 1),
    '10': m(1, 0, 0, 0, 0),
    '11': m(1, 0, 0, 0, 0),
    '12': m(1, 0, 0, 0, 0),
  },
};

function m(
  ok: number,
  salioSinEntrar: number,
  entroSinSalir: number,
  sinBanco: number,
  sinCuadrar: number,
): PCFReconciliationData['meses'][string] {
  return {
    ok, salioSinEntrar, entroSinSalir, sinBanco, sinCuadrar,
    detalles: {
      ok: mockRows(ok, 'ok'),
      salioSinEntrar: mockRows(salioSinEntrar, 'salioSinEntrar'),
      entroSinSalir: mockRows(entroSinSalir, 'entroSinSalir'),
      sinBanco: mockRows(sinBanco, 'sinBanco'),
      sinCuadrar: mockRows(sinCuadrar, 'sinCuadrar'),
    },
  };
}

function mockId() { return crypto.randomUUID().slice(0, 8); }
function mockDate(month: number) {
  const day = Math.floor(Math.random() * 28) + 1;
  return `2026-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
function mockRef() { return `FONDEO CREDITOS BMRCASH Ref. REFBNTC${String(Math.floor(Math.random() * 100000000)).padStart(8, '0')}`; }

function baseDeclared(month: number, amount: number) {
  return {
    transferId: mockId(),
    transferDate: mockDate(month),
    totalAmountMxn: amount,
    bankReference: `I${Date.now()}${Math.floor(Math.random() * 1000)}`,
    transferStatus: 'CONFIRMED',
    creditsCount: Math.floor(Math.random() * 10) + 2,
  };
}

function pairFmxFsa(fecha: string, amount: number, referencia: string) {
  return {
    salidaTxId: `fmx-${mockId()}`,
    salidaCuenta: 'fmex_mxn',
    salidaFecha: fecha,
    salidaMonto: amount,
    salidaDescripcion: 'TRASPASO ENTRE CUENTAS',
    salidaReferencia: referencia,
    salidaCodigo: 'W42',
    entradaTxId: `fsa-${mockId()}`,
    entradaCuenta: 'fsa_mxn',
    entradaFecha: fecha,
    entradaMonto: amount,
    entradaDescripcion: 'TRASPASO ENTRE CUENTAS',
    entradaReferencia: referencia,
    entradaCodigo: 'W41',
  };
}

function mockRows(count: number, type: string): Record<string, unknown>[] {
  return Array.from({ length: count }, () => {
    const month = Math.floor(Math.random() * 12) + 1;
    const amount = 5000 + Math.floor(Math.random() * 25000);
    const declared = baseDeclared(month, amount);
    const referencia = mockRef();

    switch (type) {
      case 'ok':
        return { ...declared, ...pairFmxFsa(declared.transferDate, amount, referencia), refuerzoBidireccional: true };
      case 'salioSinEntrar': {
        const par = pairFmxFsa(declared.transferDate, amount, referencia);
        return {
          ...declared,
          salidaTxId: par.salidaTxId,
          salidaCuenta: par.salidaCuenta,
          salidaFecha: par.salidaFecha,
          salidaMonto: par.salidaMonto,
          salidaReferencia: par.salidaReferencia,
          salidaCodigo: par.salidaCodigo,
        };
      }
      case 'entroSinSalir': {
        const par = pairFmxFsa(declared.transferDate, amount, referencia);
        return {
          ...declared,
          entradaTxId: par.entradaTxId,
          entradaCuenta: par.entradaCuenta,
          entradaFecha: par.entradaFecha,
          entradaMonto: par.entradaMonto,
          entradaReferencia: par.entradaReferencia,
          entradaCodigo: par.entradaCodigo,
        };
      }
      case 'sinBanco':
        return declared;
      case 'sinCuadrar':
        return { ...declared, sinCuadrarMotivo: 'Periodo no procesable: fsa_mxn=listo, fmex_mxn=sin-clasificar' };
      default:
        return declared;
    }
  });
}
